import React, { FC } from 'react'

import DefaultLayout, { DefaultLayoutProps } from '../../layouts/DefaultLayout'
import { DeclarationFormProps } from '../../components/forms/DeclarationForm'

import { HomeProps } from './Home'
import * as SC from './styled'

export type DeclarationTemplateProps = {
  className?: string
  layout?: DefaultLayoutProps
  hasToOptin?: boolean
  hasDeclaration?: boolean
  home: HomeProps
  declarationForm: DeclarationFormProps
}

const DeclarationTemplate: FC<DeclarationTemplateProps> = (props) => {
  const { layout, hasToOptin, hasDeclaration, home, declarationForm } = props

  return (
    <DefaultLayout {...layout}>
      <SC.Content>
        {hasToOptin && <SC.AcceptTerms {...declarationForm.acceptTerms} />}
        {!hasToOptin && hasDeclaration && <SC.Home {...home} />}
        {!hasToOptin && !hasDeclaration && <SC.Form {...declarationForm} />}
      </SC.Content>
    </DefaultLayout>
  )
}

export default DeclarationTemplate
